export const dotsWrapperStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '2px',
  marginRight: '4px',
  cursor: 'default',
  verticalAlign: 'middle',
};

export const getDotStyles = color => ({
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  flexShrink: 0,
  backgroundColor: ({ palette }) => color || palette.border.input,
});

export const tooltipContentStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  minWidth: '200px',
};

export const tooltipRowStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
};

export const tooltipRowHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
};

export const tooltipValuesStyles = {
  paddingLeft: '14px',
  wordBreak: 'break-word',
};
